import React from 'react';
import { FloatingPortal } from '@floating-ui/react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './Tooltip.module.scss';

const Tooltip = ({
  isMounted,
  triggerClassName,
  refs,
  animationStyles,
  styleProps,
  triggerElement,
  text,
  getReferenceProps,
  getFloatingProps,
}: {
  isMounted: any;
  triggerClassName: any;
  refs: any;
  animationStyles: any;
  styleProps: any;
  triggerElement: any;
  text: string;
  getReferenceProps: any;
  getFloatingProps: any;
}) => (
  <>
    <div
      className={cn(styles.trigger, triggerClassName)}
      ref={refs.setReference}
      {...getReferenceProps()}
    >
      {triggerElement}
    </div>
    {text && (
      <FloatingPortal>
        {isMounted && (
          <div
            className={styles.tooltip}
            ref={refs.setFloating}
            style={{ ...styleProps, ...animationStyles }}
            {...getFloatingProps()}
          >
            <Typography className={styles.text} variant="caption" mode="compact">
              {text}
            </Typography>
          </div>
        )}
      </FloatingPortal>
    )}
  </>
);

export default React.memo(Tooltip) as any;
